import { createAction } from 'typesafe-actions';

export const setSearch = createAction('SET_SEARCH', action => (searchText: string, filterKey: string) =>
  action({ searchText, filterKey })
);

export const clearSearch = createAction('CLEAR_SEARCH', action => (filterKey: string) => action({ filterKey }));
